import React from 'react';
import styled from 'styled-components';
import SearchGlobalIcon from '../assets/svgIcons/SearchGlobalIcon';
import { primaryColor, primaryFont, wMedium } from '../../../Utils/utilsStyle';

const TriggerWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
  padding: 6px 18px;
  border-radius: 20px;
  border: 1px solid ${primaryColor};
  background: #DEF6E6;
  cursor: pointer;

  .search-global-icon-svg {
    width: 14px;
    height: 14px;
  }

  .search-label {
    color: ${primaryColor};
    font-family: ${primaryFont};
    font-size: 14px;
    font-style: italic;
    font-weight: ${wMedium};
    line-height: normal;
    letter-spacing: -0.35px;
  }
`;

const SalesAlignmentSearchTrigger = function SalesAlignmentSearchTrigger() {
  return (
    <TriggerWrapper className="sales-alignment-search-trigger">
      <SearchGlobalIcon color={primaryColor} />
      <span className="search-label">Search</span>
    </TriggerWrapper>
  );
};

export default SalesAlignmentSearchTrigger;
